let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lTRHe")).then(() => parcelRequire('2NRX4'));